import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './App.css';
import { Capacitor } from '@capacitor/core';
import * as serviceWorkerRegistration from './lib/pwa/serviceWorkerRegistration';
import { backgroundSync } from './lib/pwa/backgroundSync';
import { setupIOSStoragePolyfill, setupIOSRecordingFixes } from './utils/iosStoragePolyfill';

// Capacitor platform detection for conditional imports

// Import tests in development - but not in Capacitor
// Test files removed during cleanup


// Setup iOS polyfills before app initialization
setupIOSStoragePolyfill();
setupIOSRecordingFixes();

window.addEventListener('unhandledrejection', () => {
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <App />
);

// Register service worker for PWA features (only in web, not in native apps)
if (!Capacitor.isNativePlatform()) {
  serviceWorkerRegistration.register({
    onSuccess: (registration) => {
    
      backgroundSync.init();
    },
    onUpdate: (registration) => {
   
      // Show update prompt
      import('./components/PWAUpdatePrompt').then((module) => {
        const PWAUpdatePrompt = module.default;
        const promptContainer = document.createElement('div');
        document.body.appendChild(promptContainer);
        
        const root = ReactDOM.createRoot(promptContainer);
        root.render(
          React.createElement(PWAUpdatePrompt, { registration })
        );
      });
    },
    onError: (error) => {
      console.error('Service Worker registration failed:', error);
    }
  });
}
